import React, { useState } from 'react'
import classnames from 'classnames'

export type CollapsibleRow = [React.ReactNode, React.ReactNode]

interface Props {
  title: string
  rows: CollapsibleRow[]
  defaultOpen?: boolean
}

// Renders a clickable header row and the provided rows beneath it.
// Designed to be used inside an `.index-table > tbody` to group content.
const CollapsibleTableSection: React.FC<Props> = ({ title, rows, defaultOpen }) => {
  const [open, setOpen] = useState<boolean>(defaultOpen ?? true)

  const chevronClasses = classnames('index-table__section-chevron', {
    'index-table__section-chevron--open': open,
  })

  return (
    <>
      <tr
        className="index-table__section-row"
        onClick={() => setOpen((prev) => !prev)}
        data-testid={`collapsible-${title}`}
      >
        <td className="index-table__cell" colSpan={2}>
          <div className="index-table__section-header">
            <span className="index-table__section-title">{title}</span>
            <span className={chevronClasses} />
          </div>
        </td>
      </tr>
      {open &&
        rows.map(([label, value]) => (
          <tr key={String(label)} className="index-table__row">
            <td className="index-table__cell">{label}</td>
            <td className="index-table__cell">{value as React.ReactNode}</td>
          </tr>
        ))}
    </>
  )
}

export default CollapsibleTableSection

